import SharedLayout from "utils/SharedLayout";
import { HomeRedirect } from "./HomeRedirect";
import ProfileTabs from "pages/profile/ProfileTabs";
import ChangePassword from "pages/auth/ChangePassword";
import AccountantHome from "pages/AccountantHome";
import AccountantSidebar from "components/sidebar/AccountantSidebar";
import FinalEmployeeList from "pages/final_employee_list_accountant/FinalEmployeeList";
import BioMetricTrackModule from "pages/biometric_track_module/BioMetricTrackModule";
import ManageSalary from "pages/ManageSalary/SalaryManager";
import ProcessSalary from "pages/processSalary/ProcessSalaryManager";
import BellNotifications from "pages/notification_manager/BellNotifications";
import PayrollWages from "pages/payroll_wages/PayrollWages";
import AttendanceReportModule from "pages/attendance-report/AttendanceReportModule";

const AccountantRoutes = {
  path: "/",
  element: <SharedLayout type={<AccountantSidebar />} />,
  children: [
    {
      path: "/dashboard",
      element: <AccountantHome />,
    },
    {
      path: "/all-employee-list",
      element: <FinalEmployeeList />,
    },
    {
      path: "/biometric-track-module",
      element: <BioMetricTrackModule />,
    },
    {
      path: "/manage-salary",
      element: <ManageSalary />,
    },
    {
      path: "/process-salary",
      element: <ProcessSalary />,
    },
    {
      path: "/profile",
      element: <ProfileTabs />,
    },
    {
      path: "/notification-list",
      element: <BellNotifications />,
    },
    {
      path: "/change-password",
      element: <ChangePassword />,
    },
    { path: "/attendance-report", element: <AttendanceReportModule /> },
    { path: "/payroll-wages", element: <PayrollWages /> },
    {
      path: "*",
      element: <HomeRedirect to="/dashboard" />,
    },
  ],
};

export default AccountantRoutes;
